/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscLunartime } from "../../funcs/miscGetMiscLunartime.js";
import { GetMiscLunartimeRequest$zodSchema } from "../../models/getmisclunartimeop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscLunartimeRequest$zodSchema.optional(),
};

export const tool$miscGetMiscLunartime: ToolDefinition<typeof args> = {
  name: "misc-get-misc-lunartime",
  description: `查询农历时间

需要在指定时区下查看某个时间点的农历信息？这个接口可以直接返回完整结果。

## 功能概述
支持传入 Unix 时间戳（秒或毫秒）和 IANA 时区名，返回公历时间、星期、农历年月日、干支、生肖、节气与节日信息。不传 \`ts\` 时默认使用当前时间，不传 \`timezone\` 时默认 \`Asia/Shanghai\`。

## 时区说明
- 支持标准 IANA 时区，例如 \`Asia/Shanghai\`、\`Asia/Tokyo\`
- 也支持别名：\`Shanghai\`、\`Beijing\`
- 时区非法时返回 400 并提示 \`invalid timezone: xxx\``,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscLunartime(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
